export const BusinessStatus = {
  ACTIVE: 1,
  DELETED: 2,
  UNKNOWN: 3,
  contains: function (statusId, statuses) {
    if (statuses.includes(statusId)) {
      return true;
    }
    return false;
  },
}